<template>
  <div>
    <div class="surface-card surface-card--pad mb-25">
    <div class="row" style="margin-bottom: 0">
      <div class="input-field col s12 m6">
        <i class="fas fa-dollar-sign prefix grey-text"></i>
        <input 
          name="amount"
          id="amount"
          autofocus
          v-model='amount'
          step="0.01"
          type="number"
          inputmode="decimal"
          v-validate="'min_value:0.51|required'"
          class='inputText'
          lang="en-001">
          <span class='red-text small-font' v-show='errors.first("amount")'>{{errors.first("amount")}}</span>

        <label for="amount">Amount</label>
      </div>
      <div class="input-field col s12 m6">
        <i class="fas fa-sticky-note prefix grey-text"></i>
        <input id="note" name="note" type="text" v-model="note" ref="note">

        <label for="note">Note (Name, address, etc)</label>
      </div>
      <div class="input-field col s12 m6">
        <i class="fas fa-file-invoice prefix grey-text"></i>
        <input id="invoice" name="invoice" type="text" v-model="invoice">

        <label for="invoice">Invoice</label>
      </div>
      <custom-fields v-model="customFields" flow="recurring">
        <template #default="{ definitions, values, onInput }">
          <div class="input-field col s12 m6"
               v-for="(d, idx) in definitions"
               :key="'cf-' + d.label">
            <i class="fas fa-tag prefix grey-text"></i>
            <input
              :id="'custom-field-' + idx"
              type="text"
              :maxlength="d.type === 'numerical' ? 15 : 255"
              :inputmode="d.type === 'numerical' ? 'decimal' : 'text'"
              :pattern="d.type === 'numerical' ? '\\d+(\\.\\d+)?' : null"
              :required="d.required"
              :value="values[idx]"
              @input="onInput($event.target.value, idx, d)">
            <label :for="'custom-field-' + idx">
              {{ d.label }}<span v-if="d.required"> (required)</span>
            </label>
          </div>
        </template>
      </custom-fields>
    </div>
    </div>

    <div class="surface-card surface-card--pad mb-25">
      <slot :update-token="updateToken"></slot>
    </div>

    <section class="surface-card surface-card--pad mb-25">
      <div class="bold-font">Recurring schedule: </div>
      <div class="row">
        <div class="col s12 m3 mt-10">
          <select v-model="frequency" class="browser-default" @change="on=[]">
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div class="col s6 m3 mt-10">
          Every:
          <input v-model="each" type="number" style="width: 30px; margin-top: -30px; margin-left: 10px">
           {{placeholders.frequency}}
        </div>
        <div class="col s6 m3 mt-10 input-field">
          <input name="start-date" type="date" v-model.lazy="startDate" class="datepickerX">
          <label for="start-date">Start date</label>
        </div>
        <div class="col s12 m3" style="margin-top: -10px">
          <label for="start-date">Repeat</label>
          <select v-model="count" class="browser-default">
            <option :value="null">Unlimited</option>
            <option :value="i" v-for="i in 12">{{i}}</option>
          </select>
        </div>
      </div>
      <div class="center">
        <span class="on" :class="activeOn(item[0])" @click="addOn(item[0])" v-for="item in placeholders.on">{{item[1]}}</span>
      </div>

      <div class="center emerald mt-10" v-if="!recurringStringError">
        Charge {{amount | currency}} {{recurringString}}<span v-if="totalAmountForRepeat"> for a total of {{totalAmountForRepeat | currency}}</span>, 
        starting on {{startDate}}
      </div>

      <div class="center red-text mt-10" v-else>
        {{recurringStringError}}
      </div>
    </section>

    <div class="row mt-25">
      <div class="col s12 center-align">
        <a href="/merchant/payment_events" class="btn btn-grey rounded-btn mr-10">
          <i class="fas fa-arrow-left"></i> Back
        </a>
        <button @click="charge" v-show="!showPending" class="btn emerald-back rounded-btn" :disabled="disableSubmit">
          Schedule
        </button>
      </div>
    </div>
    <center v-show='showPending' class='grey-text mt-25'>
      <i class="fas fa-spinner fa-spin"></i> Processing...
    </center>
  </div>
</template>
<script>
  import gql from 'graphql-tag'
  import customFields from './custom_fields/custom_fields'

  export default {
    props: ["userId"],
    components: {customFields},
    apollo: {
      recurringString: {
        fetchPolicy: "no-cache",
        query: gql`query($frequency: String!, $each: Int!, $on: [Int!], $count: Int) {
          merchant { recurringString(frequency: $frequency, each: $each, on: $on, count: $count) }
        }`,
        variables() {
          return {
            frequency: this.frequency,
            each: parseInt(this.each),
            on: this.on,
            count: parseInt(this.count)
          }
        },
        update(data) {
          this.recurringStringError = null
          return data.merchant.recurringString
        },
        error(error) {
          this.recurringStringError = "Invalid recurring string"
        }
      }
    },
    data() {
      return {
        amount: null,
        showPending: false,
        note: null,
        invoice: null,
        customFields: [],
        frequency: "weekly",
        each: 1,
        startDate: (new Date()).toISOString().split('T')[0],
        on: [],
        recurringString: null,
        recurringStringError: null,
        cardToken: null,
        count: null
      }
    },
    methods: {
      charge() {
        this.showPending = true
        this.$apollo.mutate({
          mutation: gql`mutation (
            $amount: Float!,
            $note: String,
            $invoice: String,
            $customFields: [CustomFieldValueInput!],
            $start_time: ISO8601Date!,
            $recurring_params: RecurringAttributes!,
            $token: String
          ) {
            createPaymentEvent(input:
              {
                amount: $amount,
                note: $note,
                invoice: $invoice,
                customFields: $customFields,
                startTime: $start_time,
                recurringParams: $recurring_params,
                token: $token
              }) {
              message errors
            }
          }`,
          // Parameters
          variables: {amount: parseFloat(this.amount), note: this.note, invoice: this.invoice, customFields: this.customFields, start_time: this.startDate, recurring_params: this.recurringParams, token: this.cardToken}
        }).then(result => {
          if(result.data.createPaymentEvent.errors.length > 0) {
            this.showPending = false
            this.notifyError(result.data.createPaymentEvent.errors[0])
          } else {
            this.notifySuccess(result.data.createPaymentEvent.message)
            Turbolinks.visit("/merchant/payment_events")
          }
        }, error => {
          this.showPending = false
          this.gqlErrorHandler(error)
        })
      },
      addOn(item) {
        if(this.on.includes(item)) {
          this.on = this.on.filter(e => e !== item)
        } else {
          this.on.push(item)
        }
      },
      activeOn(item) {
        if(this.on.includes(item)) { return "activeOn" }
      },
      updateToken(token) {
        this.cardToken = token.token
      }
    },
    computed: {
      placeholders() {
        switch(this.frequency) {
        case("weekly"):
          return {
            frequency: "week",
            on: [[0, "Sun"], [1, "Mon"], [2, "Tue"], [3, "Wed"], [4, "Thu"], [5, "Fri"], [6, "Sat"]]
          }
          break;
        case("monthly"):
          return {
            frequency: "month",
            on: Array(31).fill(1).map((x, y) => [x + y, x + y])
          }
          break;
        case("yearly"):
          return {
            frequency: "year",
            on: Array(31).fill(1).map((x, y) => [x + y, x + y])
          }
          break;
        }
      },
      disableSubmit() {
        if(this.amount > 0 && this.cardToken) {
          return false
        } else {
          return true
        }
      },
      recurringParams() {
        return {
          frequency: this.frequency,
          each: this.each,
          on: this.on,
          count: this.count
        }
      },
      cardParams() {
        return {
          token: this.cardToken.token
        }
      },
      totalAmountForRepeat() {
        if(this.count && this.amount) {
          return this.amount * this.count
        }
      }
    }
  }
</script>
<style scoped>
  .on {
    border: 2px solid #00ab8e;
    height: 30px;
    cursor: pointer;
    width: 45px;
    display: inline-block;
    margin-left: 2px;
    margin-top: 2px;
    color: #00ab8e;
  }
  .activeOn {
    color: white;
    background-color: #00ab8e;
  }
</style>
